import React from "react"
import {FieldViewSmallProps} from "../../../../render/view-small";

export default function FieldCheckbox_ViewSmall(props: FieldViewSmallProps) {

    const value = props.model[props.field.fieldId]

    return <div className={Classes("ui5-cb", "s-13", {selected: value})}/>

}